// extracted by mini-css-extract-plugin
export default {"selectCss":"SelectStyles_selectCss__jxrAb"};